// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d3e9ac3a","455":"88c387c3"}[chunkId] + ".chunk.js";
};